<div class="dsc-wrap" [ngStyle]="themeVars">
	<div class="dsc-icon-badge dsc-clickable" (click)="onIconClick()">
		<i class="material-icons">{{ icon }}</i>
	</div>

	<div class="dsc-body">
		<div class="dsc-header-extra">
			<ng-content select="[dscHeaderExtra]"></ng-content>
		</div>
		<p class="dsc-category">{{ title }}</p>

		<h3 class="dsc-value" *ngIf="!loading && value !== null && value !== undefined">{{ value }}</h3>

		<div class="dsc-spinner" *ngIf="loading">
			<svg class="spinner" width="35" height="35" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
				<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
			</svg>
		</div>
	</div>

	<div class="dsc-buckets" *ngIf="buckets?.length && !loading">
		<button type="button" class="dsc-bucket" *ngFor="let bucket of buckets; trackBy: trackBucket" (click)="onBucketClick(bucket)">
			<span class="dsc-bucket-count">{{ bucket.count }}</span>
			<span class="dsc-bucket-label">{{ bucket.label }}</span>
		</button>
	</div>

	<div class="dsc-footer" *ngIf="showView">
		<a class="dsc-view-btn dsc-clickable" (click)="onViewClick()" matTooltip="View" matTooltipPosition="below">
			<i class="material-icons">visibility</i>
			<span>View Now</span>
		</a>
	</div>
</div>
